import { Typography } from "@mui/material";
import { useState } from "react";

 export const RemarkWithToggle = ( { remark, trimmedRemark, isLong } : any) => {
    const [ showFull, setShowFull ] = useState( false );

    return (
        <div>
            <Typography
                variant="body2"
                className="all_cusWord"
                style={ {
                    color: "#5a5a5a",
                    fontStyle: "italic",
                    paddingLeft: 6,
                    lineHeight: "20px",
                } }
            >
                Remark: { showFull ? remark : trimmedRemark }
            </Typography>

            { isLong && (
                <Typography
                    variant="body2"
                    sx={ {
                        color: "primary.main",
                        cursor: "pointer",
                        fontWeight: 600,
                        fontSize: "13px",
                        marginTop: "2px",
                        paddingLeft: "6px",
                    } }
                    onClick={ () => setShowFull( !showFull ) }
                >
                    { showFull ? "View less" : "View more" }
                </Typography>
            ) }
        </div>
    );
};
